module.exports = __webpack_public_path__ + "static/media/express-pcr.3122c2e6.png";